export default "__VITE_ASSET__Do9GS9fr__";